module.exports = __webpack_public_path__ + "img/button-HYG-double.66a13c21.svg";